import Api from "./Api";

// Role-based homepage graphs. Returns { role, year, months, graphs } where the
// backend decides which graphs the caller's role sees.
export const GetRoleGraphs = async (payload) =>
  Api().post(`dashboard/graphs`, payload);
